export default __webpack_public_path__ + "navigation-examples-advanced-thumbnail-v1-480-9346f56fa731f719ee4a94e75e252da3.webp";